import AwsApiClient from '@lessonnine/api-client.js';
import {
  APIGATEWAY_BASE_URL,
  AWS_SESSION_ENDPOINT,
  AWS_SESSION_METHOD
} from 'src/dataLayer/env';
import { reportAPIFailure } from 'src/dataLayer/remoteData/rollbar';
import { LOCALE } from 'src/dataLayer/env';

const awsApiClient = new AwsApiClient({
  baseUrl: APIGATEWAY_BASE_URL,
  awsSessionEndpoint: AWS_SESSION_ENDPOINT,
  awsSessionMethod: AWS_SESSION_METHOD
});

export const authenticate = () =>
  awsApiClient.authenticate(LOCALE);

const catchApiClientFetch = async (requiresAuthentication, verb, payload) => {
  try {
    if (requiresAuthentication) {
      await authenticate();
    }
    return await awsApiClient.fetch({ verb, ...payload });
  } catch (error) {
    reportAPIFailure(error, payload);
  }
};

export const authenticatedGet = (payload) =>
  catchApiClientFetch(true, 'GET', payload);
